import React from 'react';
import { IconImage } from './icons';
interface PhotoPlaceholderProps {
  /** The exact replacement instruction shown on the block, e.g. "[REPLACE WITH APPROVED PORTRAIT — GABRIELA]" */
  label: string;
  className?: string;
  tone?: 'warm' | 'light' | 'dark';
}

/**
 * Deliberate, obviously-fake photo slot.
 * No stock imagery and no invented photos of real people are used anywhere in this page.
 *
 * TO REPLACE: swap this component for an <img> with the approved asset, e.g.
 *   <img src={approvedUrl} alt="Gabriela" loading="lazy" className="h-full w-full object-cover" />
 * The hero image must instead use loading="eager" and fetchPriority="high".
 *
 * Photography direction: warm-toned natural daylight, cream / camel / brown wardrobe.
 * NEVER apply a color overlay, duotone, gradient scrim, or heavy filter to a photograph.
 */
export function PhotoPlaceholder({
  label,
  className = '',
  tone = 'warm'
}: PhotoPlaceholderProps) {
  const toneClasses = tone === 'dark' ? 'bg-ink text-gold/85 border-gold/40' : tone === 'light' ? 'bg-white text-camelink border-camel/50' : 'bg-offwhite text-camelink border-camel/50';
  return <div role="img" aria-label={label} className={`flex h-full w-full items-center justify-center overflow-hidden border border-dashed p-4 ${toneClasses} ${className}`} data-id="element-367" data-mp="1msige3mzgf5e">
      {/* Label is bounded in its own container so it can never overlap adjacent copy. */}
      <span className="flex max-w-full flex-col items-center gap-2 text-center" data-id="element-368" data-mp="18woei4kmmq1s">
        <IconImage className="h-6 w-6 opacity-70" data-id="element-369" data-mp="13y3gmbsukigi" />
        <span className="block max-w-[20rem] break-words font-display text-[10px] font-bold uppercase leading-relaxed tracking-[0.16em]" data-id="element-370" data-mp="z0br1ofod8fh">
          {label}
        </span>
      </span>
    </div>;
}